import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { Img, Svg, Icon } from '@components/shared/elements'
import TOOLS from '@helpers/tools'
import Swiper from 'swiper/dist/js/swiper.min.js'
import './LPVivazConnection.scss'

class LPVivazConnection extends React.Component {
    componentDidMount() {
        new Swiper ('.swiper-lpcards', {
            allowTouchMove: true,
            slidesPerView: 4,
            spaceBetween: 16,
            pagination: {
                el: '.swiper-lpcards-pagination',
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                },
                1024: {
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    allowTouchMove: false,
                },
            },
        })
    }
    render() {
        return (
            <div className='lpConnection'>
                <Helmet>
                    <title>Vivaz Conecta | Vivaz</title>
                    <meta name='description' content='Chegou o Vivaz Conecta, evento que traz palestras e oportunidades de networking. Aproveite também para acompanhar os novos lançamentos da Vivaz. Saiba mais!' />
                    <script type='application/ld+json'>
                    {JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Organization',
                        name: 'Vivaz',
                        legalName: 'Vivaz Residencial',
                        url: 'https://www.meuvivaz.com.br/',
                        logo: '/Files/vivaz.com.br/content/img/brand1.svg',
                        foundingDate: '2018',
                        founders: [
                            {
                            '@type': 'Person',
                            name: 'Elie Horn',
                            },
                        ],
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: 'Rua do Rócio, 109',
                            addressLocality: 'Vila Olímpia',
                            addressRegion: 'SP',
                            postalCode: '03178-200',
                            addressCountry: 'Brasil',
                        },
                        contactPoint: {
                            '@type': 'ContactPoint',
                            contactType: 'customer support',
                            telephone: '[+55 11 4502-3333]',
                        },
                        sameAs: [
                            'https://www.facebook.com/MeuVivazResidencial/',
                            'https://www.linkedin.com/company/vivaz-residencial/',
                            'https://www.youtube.com/channel/UCILQRg7uTli8psTylY2MZ-w/featured',
                        ],
                    })}
                    </script>
                </Helmet>
                <header className='lpHeader' id='header'>
                    <div className='grid-container'>
                        <div className='cell shrink'>
                            <div className='brand'>
                            <Link to='/'>
                                <h1 className='mb0'><span className='show-for-sr'>Vivaz residencial</span></h1>
                            </Link>
                            </div>
                        </div>
                    </div>
                </header>
                <section className='lpHero' id='hero'>
                    <picture>
                        <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/dp_d.png' alt='Banner Vivaz Conecta' className='only-desktop' />
                        <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/dp_m.png' alt='Banner Vivaz Conecta' className='only-mobile'/>
                    </picture>
                </section>
                <section className='lpCadastro' id='cadastro'>
                    <div className='grid-container'>
                        <h2>Está chegando a primeira edição do Vivaz Conecta</h2>
                        <span className='cadastro-vacancy'>Vagas Limitadas!</span>
                        <a href='https://pt.surveymonkey.com/r/YCMCPJK' data-ga-name='section-esta-chegando-a-primeira-edicao-do-vivaz-conecta' data-ga-action='cta-clique-e-cadastre-se' className={`button info ${TOOLS.isMobile() ? 'expanded' : 'regular'} text`}> Clique e Cadastre-se</a>
                    </div>
                </section>
                <section className='lpProgram' id='program'>
                    <div className='grid-container'>
                        <h3>Programação</h3>
                        <div className='gallery-escape'>
                            <div className='swiper-lpcards swiper-container'>
                                <div className='swiper-wrapper mb4'>
                                    <div className='swiper-slide'>
                                        <div className='card'>
                                            <div className='card-section text-center'>
                                                <figure className='mt2'>
                                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/icon-1.png' />
                                                    <figcaption>
                                                        <p className='text'>Imersão de <strong>Facebook Ads</strong> com <strong>Fábio Prado</strong>: <i>Como potencializar suas vendas no Facebook</i>.</p>
                                                    </figcaption>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='swiper-slide'>
                                        <div className='card'>
                                            <div className='card-section text-center'>
                                                <figure className='mt2'>
                                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/icon-2.png' />
                                                    <figcaption>
                                                        <p className='text'>Conheça em primeira mão os futuros <strong>lançamentos da Vivaz</strong>.</p>
                                                    </figcaption>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='swiper-slide'>
                                        <div className='card'>
                                            <div className='card-section text-center'>
                                                <figure className='mt2'>
                                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/icon-3.png' />
                                                    <figcaption>
                                                        <p className='text'>Apresentação do <strong>Clube Vivaz</strong>. Condições especiais e o <strong>melhor comissionamento do mercado</strong>.</p>
                                                </figcaption>
                                            </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='swiper-slide'>
                                        <div className='card'>
                                            <div className='card-section text-center'>
                                                <figure className='mt2'>
                                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/icon-4.png' />
                                                    <figcaption>
                                                        <p className='text'><strong>Sorteio de prêmios.</strong></p>
                                                    </figcaption>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='swiper-slide'>
                                        <div className='card'>
                                            <div className='card-section text-center'>
                                                <figure className='mt2'>
                                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/icon-5.png' />
                                                    <figcaption>
                                                        <p className='text'>Jantar especial e <strong>networking de alto nível</strong>.</p>
                                                    </figcaption>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='hide-for-large swiper-lpcards-pagination swiper-pagination'></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='lpEvent' id='event'>
                    <div className='grid-container'>
                        <div className='grid-x align-middle'>
                            <div className='cell large-6'>
                                <picture>
                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/dk_local-d.jpg' alt='Logo Coco Bambu' className='only-desktop' />
                                    <Img src='/Files/vivaz.com.br/content/img/lp-conexao-vivaz/dk_local-m.jpg' alt='Logo Coco Bambu' className='only-mobile'/>
                                </picture>
                            </div>
                            <div className='cell large-6 lpEvent-info'>
                                <h3>Data e local</h3>
                                <p><strong>30/10/2019 às 16h30min</strong></p>
                                <p><strong>Local: Coco Bambu Anhembi</strong></p>
                                <p><strong>Entrada pela Rua Domingos Fasolari, 146 - Casa Verde</strong></p>
                                <a href='https://pt.surveymonkey.com/r/YCMCPJK' data-ga-name='section-data-e-local' data-ga-action='cta-clique-e-cadastre-se' className={`button info ${TOOLS.isMobile() ? 'expanded' : 'regular'} text`}> Clique e Cadastre-se</a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='lpKnow' id='know'>
                    <div className='grid-container'>
                        <h2>Conheça a Vivaz</h2>
                        <p>A Vivaz é uma marca do Grupo Cyrela que nasceu para construir o sonho da casa própria com o valor certo.</p>
                        <p>Uma empresa parceira, com quem você pode contar sempre.</p>
                        <p>Fazemos casas pensadas para pessoas como você: decididas, corajosas, independentes. Acreditamos que podemos fazer mais quando trabalhamos juntos. E é escutando você que a gente encontra o melhor jeito de te ajudar a realizar este sonho.</p>
                        <p>É assim que unimos nossos esforços e ideias para encontrar um jeito inteligente de juntar economia, qualidade e capricho.</p>
                        {/* <p>Em parceria com o Casa Verde e Amarela, construímos sonhos com fundações sólidas e possibilidades para todos.</p> */}
                        <p>Construímos sonhos com fundações sólidas e possibilidades para todos.</p>
                    </div>
                </section>
                <section className='lpFooter' id='footer'>
                    <div className='grid-container'>
                        <div className='grid-x row-reverse align-middle'>
                            <div className='lpFooter-social cell large-6'>
                                <div className='grid-container'>
                                    <div className='grid-x align-left'>
                                        <div className='cell small-9'>
                                            <ul className='menu social'>
                                            <li><a href='https://instagram.com/'>
                                                <Svg src='/Files/vivaz.com.br/content/img/icons/instagram.svg' />
                                            </a></li>
                                            <li><a href='https://facebook.com/'>
                                                <Svg src='/Files/vivaz.com.br/content/img/icons/facebook.svg' />
                                            </a></li>
                                            <li><a href='https://youtube.com/'>
                                                <Svg src='/Files/vivaz.com.br/content/img/icons/youtube.svg' />
                                            </a></li>
                                            </ul>
                                        </div>
                                        <div className='cell shrink'>
                                            <a href='#hero' data-smooth-scroll className='button button-back-top mb0'>
                                                <Icon icon='chevron-up' />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='lpFooter-copy text-small clearfix cell large-6'>
                                <p className='mb0'>® Vivaz Residencial Ltda. CRECI-SP J-17.592 Empresa do grupo Cyrela.</p>
                                <Link to='/termos-privacidade'>Termos e Privacidade</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default LPVivazConnection



// WEBPACK FOOTER //
// ./src/components/containers/LPVivazConnection/LPVivazConnection.js